import React from 'react';
import NoMenuLayer from 'components/NoMenuLayer';
import EmptyPage from 'components/EmptyPage';

class Notfound extends React.Component {
    render(){
        return (
            <NoMenuLayer>
                <EmptyPage title='Sorry,page does not exist' hasIndexButton />
            </NoMenuLayer>
        );
    }
};

export default Notfound;



// WEBPACK FOOTER //
// ./src/pages/Notfound/index.js